import { Row } from '../../../../../coaching-observation/experimental.grid';
import { CellContext, RowContext } from '../commitment-narrative.model';

export function filterRowsByLastUpdatedBy(
    lastUpdatedBy: string[] | undefined,
    rows: Array<Row<RowContext, CellContext>>,
): Array<Row<RowContext, CellContext>> {
    if (lastUpdatedBy == null || lastUpdatedBy.length === 0) {
        return [...rows];
    }

    return rows.filter(
        (row) =>
            row.ctx != null && lastUpdatedBy.includes(row.ctx.lastUpdatedBy),
    );
}
